import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DescriptionContentDate = styled.div.attrs({
  id: 'descriptionContentDate',
})<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['light']};
  font-size: ${30 * Screen.widthRatio}px;
`;

export default DescriptionContentDate;
